import env from './env'

// A feature is keyed by market, then optionally by environment. A feature that
// is being tried out by named people instead of rolled out to a market uses
// `users` — an email allowlist that ignores market and environment entirely.
const FEATURES = {
  documents: { AT: true },
  leads: { DE: true, CH: true },
  wellpass: { DE: true },
  templates: true,
  membBillAdj: { CH: true },
  // The new my page (mypage-ui-next). Live for NO, where it replaces the old
  // "View my page" button; elsewhere still under test by the listed people, who
  // get a "View my page (next)" button beside the old one.
  mypageNext: {
    NO: true,
    users: [
      'teknisk@fitnessgroup.no',
      'leo.lindberg@evofitness.no',
      'leo.lindberg@evo.no',
      'schjelle@gmail.com',
      'leo.furlong@evo.no',
      'peter@fitnessgroup.no',
      'marte.finnland@evo.no',
      'ronja.kvaloe@fitnessgroup.no',
      'morten.hellevang@fitnessgroup.no',
      'Andreas.skjetne@evofitness.no',
      'linneaqin@gmail.com',
      'geir.gluckstad@evo.no',
      'peter.byman@evofitness.fi'
    ]
  }
}

const OPERATORS = {
  '051b413f-0245-4e84-9228-f3c7c5f8d299': 'AT',
  '4de2a7cb-bd28-4111-aa28-4bbcdf60f533': 'CH',
  'c04bc7c3-903f-4804-a952-9abc0016b824': 'DE',
  '5336003e-0105-4402-809f-93bf6498af34': 'NO'
}

const featureEnabled = (name, operatorId, email) => {
  if (!FEATURES[name]) return false
  if (typeof FEATURES[name] === 'boolean') return FEATURES[name]

  const feature = FEATURES[name]

  // An allowlisted person gets the feature in every market; anyone else gets it
  // only where it is rolled out. A feature with `users` and no market keys stays
  // closed to everyone not on the list, since checkLevel finds no market.
  if (feature.users && email && feature.users.includes(email)) return true

  return checkLevel(feature, [OPERATORS[operatorId], env()])
}

const checkLevel = (feature, keys) => {
  if (!feature[keys[0]]) return false
  if (typeof feature[keys[0]] === 'boolean') return feature[keys[0]]
  if (keys.length === 1) return feature[keys[0]] || false
  return checkLevel(feature[keys[0]], keys.slice(1))
}

export {
  featureEnabled
}
